<template>
  <div class="space-y-3 rounded-md border border-gray-200 p-4">
    <h4 class="text-sm font-semibold text-gray-900">{{ title }}</h4>
    <div class="grid grid-cols-2 gap-3">
      <CtifFieldRow v-model="model.name" :label="$gettext('Dénomination')" required />
      <CtifFieldRow v-model="model.legal_form" :label="$gettext('Forme légale')" required />
      <CtifFieldRow v-model="model.incorporation_date" :label="$gettext('Date de constitution')" type="date" />
      <CtifFieldRow v-model="model.company_number" :label="$gettext('Numéro d\'entreprise')" required />
      <CtifFieldRow v-model="model.economic_activities" :label="$gettext('Activités économiques')" />
    </div>
    <h5 class="mt-2 text-xs font-semibold uppercase text-gray-500">{{ $gettext("Adresse") }}</h5>
    <div class="grid grid-cols-2 gap-3">
      <CtifFieldRow v-model="address.street" :label="$gettext('Rue')" required />
      <CtifFieldRow v-model="address.number" :label="$gettext('Numéro')" />
      <CtifFieldRow v-model="address.zipcode" :label="$gettext('Code postal')" required />
      <CtifFieldRow v-model="address.city" :label="$gettext('Localité')" required />
      <CtifFieldRow v-model="address.country" :label="$gettext('Pays')" required />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import CtifFieldRow from "@/components/ctif/CtifFieldRow.vue";

const props = defineProps({
  modelValue: { type: Object, required: true },
  title: { type: String, default: "Personne morale" },
});

const model = computed(() => props.modelValue);
const address = computed(() => props.modelValue.address);
</script>
